import { createContext, useContext } from 'react';

import type { TileAvailability, TilePermissionResolvers } from './types';

export type TileAvailabilityContextValue = {
    readonly availabilityByType: ReadonlyMap<string, TileAvailability>;
    readonly permissionResolvers: TilePermissionResolvers;
};

const TileAvailabilityContext = createContext<TileAvailabilityContextValue | null>(null);

export const TileAvailabilityProvider = TileAvailabilityContext.Provider;

export const useOptionalTileAvailability = (): TileAvailabilityContextValue | null =>
    useContext(TileAvailabilityContext);
